// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function requestOrders(data) {
  return {
    type: types.ORDERS_REQUEST,
    data,
  };
}
export function ordersRequestSuccess(response) {
  return {
    type: types.ORDERS_REQUEST_SUCCESS,
    response
  };
}
export function ordersRequestFailed(error) {
  return {
    type: types.ORDERS_REQUEST_FAILED,
    error
  };
}

export function startLoading() {
  return {
    type: types.ORDERS_START_LOADING,
  };
}

export function stopLoading() {
  return {
    type: types.ORDERS_STOP_LOADING,
  };
}

export function resetOrders() {
  return {
    type: types.ORDERS_RESET,
  };
}
